import React from 'react';

import { InputNumber as AntDInputNumber } from 'antd';
import styled from 'styled-components';

const StyledInputNumber = styled(AntDInputNumber)`
  display: flex;
  align-items: center;
  background-color: var(--background-gray);
  border: 1px solid var(--line-gray);
  border-radius: 0;
  vertical-align: middle;
  line-height: normal;
  .ant-input-number-prefix {
    padding-top: 1px;
  }
`;

const InputNumber = (props: any) => {
  return <StyledInputNumber size={'middle'} style={{ display: 'flex', alignItems: 'center' }} {...props} />;
};

export default InputNumber;
